"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCheckboxContainer = exports.StyledCheckBoxIndicator = exports.StyledCheckBox = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var RadixCheckBox = _interopRequireWildcard(require("@radix-ui/react-checkbox"));
var StyledCheckboxContainer = exports.StyledCheckboxContainer = _styledComponents.default.div.withConfig({
  displayName: "Checkboxstyled__StyledCheckboxContainer",
  componentId: "sc-1dml145-0"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;gap:", ";"], function (props) {
  return props.theme.sys.spacing['200'];
});
var StyledCheckBox = exports.StyledCheckBox = (0, _styledComponents.default)(RadixCheckBox.Root).withConfig({
  displayName: "Checkboxstyled__StyledCheckBox",
  componentId: "sc-1dml145-1"
})(["display:flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:", ";border:1px solid ", ";background:", ";&[aria-checked='true'],&[aria-checked='mixed']{background:", ";border-color:", ";}&[disabled]{background:", ";border-color:", ";}"], function (props) {
  return props.theme.sys.size.borderradius['2'];
}, function (props) {
  return props.theme.sys.color.border.enabled;
}, function (props) {
  return props.theme.sys.color.background.neutral['1'];
}, function (props) {
  return props.bgColor || props.theme.sys.color.background.primary['3'];
}, function (props) {
  return props.bgColor || props.theme.sys.color.border.active;
}, function (props) {
  return props.theme.sys.color.background.disabled['1'];
}, function (props) {
  return props.theme.sys.color.border.disabledondisabled;
});
var StyledCheckBoxIndicator = exports.StyledCheckBoxIndicator = (0, _styledComponents.default)(RadixCheckBox.Indicator).withConfig({
  displayName: "Checkboxstyled__StyledCheckBoxIndicator",
  componentId: "sc-1dml145-2"
})(["div > svg > path{fill:", ";}"], function (props) {
  return props.color ? props.color : undefined;
});